
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 142.28 128.08"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"-1185.17","y1":"637.27","x2":"-1184.4","y2":"637.98","gradientTransform":"matrix(118.11 0 0 128.16 140009.2 -81652.47)","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#304c7e"}}),_c('stop',{attrs:{"offset":".83","stop-color":"#050c1e"}})])]),_c('g',{attrs:{"data-name":"Livello 2"}},[_c('g',{attrs:{"data-name":"Livello 1"}},[_c('g',{attrs:{"data-name":"Group 48"}},[_c('path',{attrs:{"data-name":"Path 149","d":"M81.07 128a63.71 63.71 0 01-51-21.8A8.68 8.68 0 0131 94c.3-.3.7-.5 1-.8l4.3-2.8A8.59 8.59 0 0147.37 92a41.69 41.69 0 102.7-58.9 37.16 37.16 0 00-5.6 6.3 8.56 8.56 0 01-10.8 2.6l-4.6-2.1a8.57 8.57 0 01-4-11.5c.2-.4.4-.7.6-1.1A64.07 64.07 0 1181.07 128z","fill":"url(#a)"}})]),_c('path',{attrs:{"data-name":"Path 150","d":"M65 50.72a25.18 25.18 0 00-4.4 6.4 9.64 9.64 0 01-8.8 5.7H40.11a9.86 9.86 0 01-8.5-4.8 17 17 0 10-6.1 23.2 17.81 17.81 0 006.1-6.1 9.86 9.86 0 018.5-4.8h11.7a9.53 9.53 0 018.8 5.7 22.1 22.1 0 004.4 6.4 23.2 23.2 0 0032.1.4 22.64 22.64 0 00.4-32.1l-.4-.4a23.1 23.1 0 00-32.11.4z","fill":"#217fb4"}})])])])
          )
        }
      }
    